// models/metrics/metasearchMetrics/tripadvisor-sp/tripadvisorMetaMetrics.js

// connectivity

// conversion
import MetricBookingCountTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/conversion/MetricBookingCount";
import MetricConversionTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/conversion/MetricConversion";
import MetricPaidClicks from "models/metrics/metasearchMetrics/tripadvisor-sp/conversion/MetricPaidClicks";

// performance
import MetricClicksTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/performance/MetricClicks";
import MetricCpcTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/performance/MetricCpc";
import MetricCsrTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/performance/MetricCsr";
import MetricCtrTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/performance/MetricCtr";
import MetricSpentTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-sp/performance/MetricSpent";

// visibility
import MetricAvailPassRate from "models/metrics/metasearchMetrics/tripadvisor-sp/visibility/MetricAvailPassRate";
import MetricPlmPassRate from "models/metrics/metasearchMetrics/tripadvisor-sp/visibility/MetricPlmPassRate";
import MetricShareOfVoice from "models/metrics/metasearchMetrics/tripadvisor-sp/visibility/MetricShareOfVoice";
import MetricWinAdjacentOrganic from "models/metrics/metasearchMetrics/tripadvisor-sp/visibility/MetricWinAdjacentOrganic";
import MetricWinOtherSuppliers from "models/metrics/metasearchMetrics/tripadvisor-sp/visibility/MetricWinOtherSuppliers";

// others

const tripadvisorSpMetrics = [
    // connectivity

    // conversion
    new MetricBookingCountTripadvisor(),
    new MetricConversionTripadvisor(),
    new MetricPaidClicks(),
    // performance
    new MetricClicksTripadvisor(),
    new MetricCpcTripadvisor(),
    new MetricCsrTripadvisor(),
    new MetricCtrTripadvisor(),
    new MetricSpentTripadvisor(),
    // visibility
    new MetricAvailPassRate(),
    new MetricPlmPassRate(),
    new MetricShareOfVoice(),
    new MetricWinAdjacentOrganic(),
    new MetricWinOtherSuppliers()

    // others
];

export function findMetricById(metricId) {
    return tripadvisorSpMetrics.find((metricClass) => metricClass.field === metricId);
}

export default tripadvisorSpMetrics;
